import type { NextPage, GetServerSideProps } from 'next'

import { Layout } from '../components/Layout'
import { PageConfig } from '../types/page_component_types'
import { PageTemplate } from '../components/PageTemplate'
import { getPagePropsBySlug } from '../utils/get_page_props_by_slug'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { Locale } from '../types/shared_types'

// https://www.iubenda.com/en/privacy-policy-generator/1202353/edit

const Cookies: NextPage<{
  pageConfig: PageConfig
}> = ({ pageConfig }) => {
  const router = useRouter()

  const locale = (router.locale || 'en') as Locale

  return (
    <Layout config={pageConfig}>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <PageTemplate
        content={[
          {
            type: 'html',
            block: `<a href="https://www.iubenda.com/privacy-policy/${
              locale === 'en'
                ? process.env.NEXT_PUBLIC_IUBENDA_POLICYID_EN
                : process.env.NEXT_PUBLIC_IUBENDA_POLICYID_DE
            }/cookie-policy" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iub-no-markup iubenda-noiframe iub-body-embed" title="Cookie Policy"></a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>`
          }
        ]}
      />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await getPagePropsBySlug(context, '')
}

export default Cookies
